'use strict';

import Api from "./Api";
import qs from 'qs';

export default class Client extends Api {

    static getList(page = 1, perPage = 10, filter = {}, sort = undefined) {
        const url = this.url + 'client/list';

        return this.getAxios().get(url, {
            params: {
                page: page,
                'per-page': perPage,
                filter: filter,
                sort: sort,
            },
            paramsSerializer: params => qs.stringify(params),
        });
    }

    static get(id) {
        const url = this.url + 'client/get';

        return this.getAxios().get(url, {
            params: {
                id: id,
            },
        });
    }

    static getSale(id) {
        const url = this.url + 'client/get-sale';

        return this.getAxios().get(url, {
            params: {
                id: id,
            },
        });
    }

    static add(data) {
        const url = this.url + 'client/add';

        return this.getAxios().post(url, data);
    }

    static update(data) {
        const url = this.url + 'client/update';

        return this.getAxios().post(url, data);
    }

    static setResponsible(data) {
        const url = this.url + 'client/set-responsible';

        return this.getAxios().post(url, data);
    }

    static setManager(data) {
        const url = this.url + 'client/set-manager';

        return this.getAxios().post(url, data);
    }

    static setStatus(clientId, subStatus, text = '') {
        const url = this.url + 'client/set-status';

        return this.getAxios().post(url, {
            id: clientId,
            sub_status: subStatus,
            text: text,
        });
    }

    static find(query) {
        const url = this.url + 'client/find';

        return this.getAxios().get(url, {
            params: {
                w: query,
            }
        });
    }

    static getSubscriptionsByClient(clientId) {
        const url = this.url + 'client/subscriptions-list-by-client';

        return this.getAxios().get(url, {
            params: {
                clientId: clientId,
            },
        });
    }

    static getDebts(clientId) {
        const url = this.url + 'client/debts-list';

        return this.getAxios().get(url, {
            params: {
                clientId: clientId,
            },
        });
    }

    static debtClose(id, paymentType, drop = false, comment = '') {
        const url = this.url + 'client/debt-close';

        return this.getAxios().post(url, {
            id: id,
            paymentType: paymentType,
            drop: drop === true ? 1 : 0,
            comment: comment,
        });
    }


    static getSms(clientId, page = 1, perPage = 10, sort = undefined, extraFields = []) {
        const url = this.url + 'client/sms-list';

        return this.getAxios().get(url, {
            params: {
                client_id: clientId,
                page: page,
                'per-page': perPage,
                sort: sort,
                expand: extraFields.join(','),
            },
        });
    }
}
